module.exports = __webpack_public_path__ + "static/media/img-cover-01.4ba1cb67.png";